import {
    DKDataGrid,
    DKLabel,
    DKIcons,
    INPUT_TYPE,
    shiftArrayElement,
    DKIcon,
    DKTooltipWrapper,
    DKButton,
    showAlert,
    showToast,
    TOAST_TYPE
} from "deskera-ui-library";
import { useEffect, useRef, useState } from 'react';
import { COLUMN_CODE, TableManger, TABLES, TABLE_DISPLAY_NAME } from '../../managers/TableManger';
import { AddRecordButtonConfig, IColumn } from '../../model/Table';
import ContextMenu from './ContextMenu';
import ic_visibility from '../../assets/icons/white/ic_visibility.png'
import SideBarService from '../../services/sidebar';
import ic_autorenew from '../../assets/icons/white/ic_autorenew.png'
import ic_check_mark from "../../assets/icons/check.svg";
import ReactTooltip from 'react-tooltip';
import ic_file_blue from "../../assets/FilesIcons/file_blue.svg";
import ic_upload from "../../assets/icons/ic_upload.png";
import PDF_ICON from "../../assets/file/PDF.svg"
import { TENANT, TenantService } from '../../managers/TenantManagerService';
import ic_no_data from "../../assets/icons/ic_no_data_3.png";
import Utility  from "../../utility/Utility";
import { isViewportLarge } from "../../utility/ViewportSizeUtils";
import { CANDIDATE_ACCEPT_FILE_TYPE, ENTITY, FILE_TYPE, REACT_TOOLTIP_CONST } from "../../constants/Constant";
import i18next from "i18next";
import ExpenseService from "../../services/ExpenseService";
import { stringSanitizer } from '../../managers/common/CommonUtil';
import Table from '../../services/table';
import { STATUTORY_CONSTANT } from '../reports/ReportsConstants';
import PermissionUtils, { ACTION, MODULE } from '../user-permissions/PermissionUtils';

export interface IDataGridHolderPayrollProps {
    tableName: string;
    displayTableName?: string;
    filter?: any;
    allowExpand?: boolean;
    allowRowEdit?: boolean;
    allowColumnEdit?: boolean;
    allowRowAdd?: boolean;
    allowColumnAdd?: boolean;
    allowColumnDelete?: boolean;
    allowColumnShift?: boolean;
    allowSearch?: boolean;
    allowFilter?: boolean;
    allowDataExport?: boolean;
    allowColumnSort?: boolean;
    allowBulkOperation?: boolean;
    onRowExpand?: (data: any) => void;
    onRowUpdate?: (data: any) => void;
    onColumnUpdate?: (data: any) => void;
    onColumnShift?: (data: any) => void;
    onRowAdd?: (data: any) => void;
    onRowClick?: (rowIndex: any, rowData: any) => void;
    onColumnAdd?: (data: any) => void;
    onColumnDelete?: (data: any) => void;
    onSearch?: (searchTerm: any) => void;
    onFilter?: (updatedData: any[], config: any[]) => void;
    onRowDelete?: (data: any) => void;
    onRowEdit?: (data: any, isFromRowOpen?:any) => void;
    onCancelContext?:() => void;
    onRowSelect?: (data: any) => void;
    onPaginationClick?: (requestedPageNumber: any) => void;
    onClockIn?: (data: any) => void;
    onClockOut?: (data: any) => void;
    addButtonConfig?: AddRecordButtonConfig;
    refresh: boolean;
    currentPage?: number;
    totalPageCount?: number;
    gridData?: any;
    width?: string | number;
    onRowDetailedView?:(data:any) => void;
    onTerminateEmployee? : (data: any) => void
    onView? : (data: any) => void
    onDownloadAttachment? : (data: any) => void
    onDesignDocument? : (data: any) => void
    isActionEnabled?: boolean;
    onProcessPayroll?:(data: any) => void;
    onStatusChange? :(data: any) => void;
    contextMenu?: boolean;
    gridWidth?: number;
    isMenuVisible?:boolean;
    showContextEdit ? : boolean
    isHeaderHidden?:boolean;
    onSelection?: (data: any) => void;
    onRowOpenBtnHidden? :boolean;
    isActionColumnFirst? :boolean;
    isHideTooltip? :boolean;
    isShowRevert?:boolean;
    onRowSelectActionBtn? :any;
    onRevertClick?:(data)=>void;
    latestProcessedPayrollId?:any;
    onDocumentDownloadSigned?: (data: any, isSigned: boolean) => void;
    onDocumentUploadSigned?: (data: any, isSigned: boolean) => void;
    onDocumentDelete?: (data: any, isSigned: boolean) => void;
    onDocumentUploadAndReplace?: (data: any, isSigned: boolean) => void;
    onSort?:(data:any) =>void;
    addMenuButton?: any ;
    uploadFile?: (data:any)=>void;
    dateFormat?: string;
    hideTableName?: any;
    onCheckPrint?:() => void;
    isCheckPrint?:boolean;
    needTrailingColumn?: boolean;
    makePayment?: (data:any)=> void;
    isHideContextMenuWhenRowExpanded?: boolean;
    openDetail?: (data:any) => void;
    noDataTopHeight?:number;
    onSubmit? :(data:any)=> void;
    onApproveReject? :(data:any,isApprove:any)=> void;
    updating?: boolean
    formType?: any;
    module? : any;
    
}
export interface IDataGridHolderPayrollState {
    tableName: string;
    columns: IColumn[];
    rows: any[];
    currentPage: number;
    totalPageCount: number;
    showContextMenu: boolean;
    needNoDataView: boolean;
    filter: any[];
    originalData: any[];
    width: number;
    isAllRowSelected: boolean;
    onRowOpenBtnHidden?:boolean;
    isShowRevert?:boolean;
    attachmentData?:any;
    isRowExpanded?:boolean;
    hasAccess?:any;
    // gridWidth?: number;
}

const DataGridHolderPayroll: React.FC<IDataGridHolderPayrollProps> = (props) => {
    const mounted: React.MutableRefObject<boolean> = useRef(false);

    const initialState: IDataGridHolderPayrollState = {
        tableName: '',
        columns: [],
        rows: [],
        currentPage: 1,
        totalPageCount: 1,
        showContextMenu: false,
        needNoDataView: false,
        filter: [],
        originalData: [],
        width: SideBarService.getContainerWidth(),
        isAllRowSelected:false,
        attachmentData:null
    };
    const [state, setState] = useState<IDataGridHolderPayrollState>(initialState);
    let [selection, setSelection] = useState<any[]>([]);
    const [width, setWidth] = useState(SideBarService.getContainerWidth())
    const attachmentOpenFileRef:React.MutableRefObject<any>  = useRef()
    const [attachmentPickerExists, setAttachmentPickerExists] = useState(false)
    useEffect(() => {
        setSelection([])
    },[props])

    useEffect(() => {
        window.addEventListener("resize", windowSizeUpdated);
        window.addEventListener('onSideBarChange', windowSizeUpdated);
        if (!mounted.current) {
            // do componentDidMount logic
            mounted.current = true;
        } else {
            // do componentDidUpdate logic
            setState({
                ...state,
                tableName: props.tableName,
                rows: props.gridData.rowData,
                columns: props.gridData.columnData,
                filter: props.filter,
                originalData: props.gridData.originalData || [],
                needNoDataView: props.gridData.rowData.length === 0,
                currentPage: props.currentPage ?? 1,
                totalPageCount: props.totalPageCount ?? 1,
                showContextMenu:false,
                isAllRowSelected:false,
                onRowOpenBtnHidden: ((props.onRowOpenBtnHidden) ? props.onRowOpenBtnHidden: false),
                isShowRevert:  false,
                hasAccess: PermissionUtils.hasAccess(props.module, [ACTION.EDIT,ACTION.CREATE])
            });
            if (props.tableName == TABLES.PEOPLE_MULTIPLE_EXPENSE && !Utility.isEmpty(state.columns)) {
                updateColumns()
            }
            setTimeout(() => {
                
                ReactTooltip.rebuild();
            },1000)
        }
        return () => {
            setState(initialState);
            window.removeEventListener("resize", windowSizeUpdated);
            window.removeEventListener('onSideBarChange', windowSizeUpdated);
        };
    }, [props]);

    const windowSizeUpdated = () => {
        setWidth(SideBarService.getContainerWidth())
    };

    const getNoDataView = () => {
        return (
            <div
                className="column align-self-center align-items-center position-absolute"
                style={{ top: `${props.noDataTopHeight ? props.noDataTopHeight : "30"}%` , pointerEvents: "none" }}
            >
                <DKIcon
                    src={ic_no_data}
                    className="ic-l"
                    style={{ opacity: 0.2, marginTop: 90 }}
                />
                <DKLabel text="No data found" className="fw-m mt-l" />
                <DKLabel
                    text="Once data is available, it will appear here"
                    className="text-gray mt-s "
                />
            </div>
        );
    };

    const getActionButtonsColumn = () => {
        let options = []

        let editIcon = {
            // icon: DKIcons.ic_edit,
            title: "Edit",
            className:'p-0 text-app fw-m text-underline',
            onClick: (data: any) => {
                if (props.onRowEdit) {
                    props.onRowEdit(data);
                }
            }
        }

        if(props.tableName === TABLES.PAYSTUB_LIST || props.displayTableName === TABLE_DISPLAY_NAME[TABLES.PAYMENT_SUMMARY]){
            let pdfIcon = {
                icon: PDF_ICON,
                title: "",
                className:'p-0 text-app fw-m text-underline',
                onClick: (data: any) => {
                    if (props.onDownloadAttachment) {
                        props.onDownloadAttachment(data);
                    }
                }
            }
            let design = {
                // icon: PDF_ICON,
                title: "Design",
                className:'p-0 text-app fw-m text-underline',
                onClick: (data: any) => {
                    if (props.onDesignDocument) {
                        props.onDesignDocument(data);
                    }
                }
            }
            options.push(pdfIcon)
            const isAdmin = TenantService.get(TENANT.IS_ADMIN);
            if(isAdmin) {
                options.push(design)
            }


        } else if(props.tableName == TABLES.IMPORT_LOG){
            let icon = {
                icon: ic_file_blue,
                title: "",
                className:'p-0 text-app fw-m fs-l text-underline',
                onClick: (data: any) => {
                    if (props.onDownloadAttachment) {
                        props.onDownloadAttachment(data);
                    }
                }
            }
            options.push(icon)
        } else if(props.tableName === TABLES.CUSTOME_FIELD_LIST || props.tableName === TABLES.PEOPLE_ASSIGN_MEMBERS){
            let deleteIcon = {
                // icon: DKIcons.ic_edit,
                title: "Delete",
                className:'p-0 text-app fw-m text-underline',
                onClick: (data: any) => {
                    if (props.onRowDelete) {
                        props.onRowDelete(data);
                    }
                }
            }
            if(PermissionUtils.hasAccess(props.module,[ACTION.EDIT])) {
                options.push(editIcon);
            }
            
        } else if (props.tableName == TABLES.PEOPLE_DOCUMENT) {
            options.push({
                title: "Download",
                className:'p-0 text-app fw-m text-underline',
                onClick: (data: any) => {
                    if (props.onDocumentDownloadSigned) {
                        props.onDocumentDownloadSigned(data, false);
                    }
                }
            })
        } else if(props.tableName == TABLES.PEOPLE_EXPENSE_GROUP) {
            options.push({
                title: "View",
                className:'p-0 text-app fw-m text-underline',
                onClick: (data: any) => {
                    if (props.onRowEdit) {
                        props.onRowEdit(data);
                    }
                }
            })
        } else if(props.tableName == TABLES.PEOPLE_EXPENSE_GROUP_USER && PermissionUtils.hasAccess(MODULE.EXPENSE_ADMIN_SETTING,[ACTION.EDIT])) {
            options.push({
                title: "Move User",
                className:'p-0 text-app fw-m text-underline',
                onClick: (data: any) => {
                    if (props.onRowEdit) {
                        props.onRowEdit(data);
                    }
                }
            })
        } else if(props.tableName == TABLES.PEOPLE_ATTENDANCE_SETTING || props.tableName ==  TABLES.PEOPLE_LOCATION_EMPLOYEE_MAPPING || props.tableName == TABLES.PEOPLE_COMPONENT_FORMULA){
            let deleteIcon = {
                // title: "Delete", will use later
                icon: DKIcons.ic_delete,
                className:'p-0 text-app fw-m text-underline',
                onClick: (data: any) => {
                    if (props.onRowDelete) {
                        props.onRowDelete(data);
                    }
                }
            }
            if(PermissionUtils.hasAccess(props.module,[ACTION.DELETE])) {
                options.push(deleteIcon);
            }
        } else if(props.tableName == TABLES.PEOPLE_GIRO && PermissionUtils.hasAccess(props.module,[ACTION.CREATE,ACTION.EDIT])) {
            options.push({
                // icon: DKIcons.ic_edit,
                title: "MAKE PAYMENT",
                className:'p-0 text-app fw-m ',
                onClick: (data: any) => {
                    if (props.makePayment) {
                        props.makePayment(data);
                    }
                }
            })
        } else if (props.tableName === TABLES.PEOPLE_PAYMENT_LOGS) {
            options.push({
                title: "Download",
                className:'p-0 text-app fw-m text-underline',
                onClick: (data: any) => {
                    if (props.onDownloadAttachment) {
                        props.onDownloadAttachment(data);
                    }
                }
            })
        } else if (props.tableName == TABLES.PEOPLE_SHIFT_MEMBERS) {
            options.push({
                title: "View",
                className: 'p-0 text-app fw-m text-underline',
                onClick: (data: any) => {
                    if (props.onRowEdit) {
                        props.onRowEdit(data);
                    }
                }
            });
        } else if (props.tableName == TABLES.PEOPLE_IRAS_AIS_SUBMISSION_LOGS) {
            options = [];
        } else if (props.tableName == TABLES.PEOPLE_OVERTIME_LIST && PermissionUtils.hasAccess(props.module,[ACTION.EDIT])) {
            options.push(editIcon);

        } else if(props.tableName == TABLES.PEOPLE_OVERTIME_RATE_CONFIG) {
            let deleteIcon = {
                icon: DKIcons.ic_delete,
                className:'p-0 text-app fw-m text-underline',
                onClick: (data: any) => {
                    if (props.onRowDelete) {
                        props.onRowDelete(data);
                    }
                }
            }
            
            if(PermissionUtils.hasAccess(props.module,[ACTION.DELETE])) {
                options.push(deleteIcon);
            }
        } else if (props.tableName === TABLES.PEOPLE_MANAGE_COMP_OFF_REQUESTS){
            options = [];
            
        } else if (props.tableName === TABLES.PEOPLE_EXPENSE_CLAIMS || props.tableName === TABLES.PEOPLE_FORM16) {
            options = [];
        } else if(props.tableName === TABLES.PEOPLE_APPLY_COMP_OFF_REQUEST) {
            options.push(editIcon)
        } else if (props.tableName === TABLES.POLICY_AND_RESOURCES) {
            const view = {
                title: "View",
                className: 'p-0 text-app fw-m text-underline',
                onClick: (data: any) => {
                    if (props.onView) {
                        props.onView(data);
                    }
                }
            };

            if (PermissionUtils.hasAccess(props.module, ACTION.VIEW)) {
                options.push(view);
            }
        } else if(PermissionUtils.hasAccess(props.module,[ACTION.EDIT])) {
            options.push(editIcon)
        }

        let actionColumnName = "Actions";
        let actionColumnWidth = 150;
        let width = 150;
        switch(props.tableName) {
            case TABLES.PAYSTUB_LIST:
                actionColumnName = "Paystubs";
                break;
            case TABLES.PEOPLE_COMPONENT:
            case TABLES.PEOPLE_EXPENSE_GROUP:
            case TABLES.PEOPLE_EXPENSE_GROUP_USER:
                actionColumnWidth = 200;
                break;
            case TABLES.PAYROLL_SUMMARY:
                actionColumnName = "Check View / Design";
                width = 200;
                break;
            case TABLES.PEOPLE_COMPONENT_FORMULA:
                actionColumnWidth = 90
                break;
            case TABLES.PEOPLE_EMPLOYEE_TAX_DECLARATION:
                options = [];
                break;
            case TABLES.PEOPLE_APPRAISAL_CYCLES:
                if(PermissionUtils.hasAccess(props.module,[ACTION.EDIT])) {
                    options = [editIcon];
                }
                
                break;
            case TABLES.PEOPLE_MULTIPLE_EXPENSE: 
                options = [ ]
                break;
            case TABLES.POLICY_AND_RESOURCES:
                actionColumnWidth = 250;
                break;
        }
        return {
            key: 'actions',
            name: actionColumnName,
            className:'p-0',
            type: INPUT_TYPE.BUTTON,
            width: actionColumnWidth,
            options
        };
    };
    const getGridContextMenu = () => {
        let options = [];
        let edit = {
            title: "Edit123",
            icon: DKIcons.ic_edit,
            onClick: (data) => {
              if (props.onRowEdit) {
                  props.onRowEdit(data);
              }
            },
          }

          let deleteRow =  {
            title: "Delete",
            icon: DKIcons.ic_delete,
            onClick: (data) => {
              if (props.onRowDelete) {
                  props.onRowDelete(data);
              }
            }
          };
          let terminate = {
            title: 'Terminate',
            icon: DKIcons.ic_close,
            className:'p-0',
            onClick: (data: any) => {
                if (props.onTerminateEmployee) {
                    props.onTerminateEmployee(data);
                }
            }
        }

        let employeeView = {
            title: 'View',
            icon: ic_visibility,
            className:'p-0',
            onClick: (data: any) => {
                if (props.onView) {
                    props.onView(data);
                }
            }
        }

        switch (props.tableName) {
          case TABLES.PEOPLE_EMPLOYEE_TAX_DECLARATION:
            options = [];
            break;

          case TABLES.PAYROLL:
            let viewPayroll = {
              title: "View",
              icon: ic_visibility,
              onClick: (data: any) => {
                if (props.onRowDetailedView) {
                  props.onRowDetailedView(data);
                }
              },
            };
            let processPayroll = {
              title: "Process",
              icon: ic_autorenew,
              onClick: (data: any) => {
                if (props.onProcessPayroll) {
                  props.onProcessPayroll(data);
                }
              },
            };
            if(PermissionUtils.hasAccess(props.module,[ACTION.EDIT])) {
                options = [...options,edit];
            }
            if(PermissionUtils.hasAccess(props.module,[ACTION.DELETE])) {
                options = [...options,deleteRow];
            }
            options = [...options,viewPayroll];
            if(PermissionUtils.hasAccess(props.module,[ACTION.SUBMIT])) {
                options = [...options,processPayroll];
            }
            
            break;
          case TABLES.EMPLOYEE_LIST:
            if(PermissionUtils.hasAccess(props.module,[ACTION.DELETE])) {
                options = [...options,deleteRow];
            }
            if(PermissionUtils.hasAccess(props.module,[ACTION.EDIT])) {
                options = [...options,terminate];
            }
            options = [...options, employeeView];
            break;
          case TABLES.CONTRACTOR_LIST:
            if(PermissionUtils.hasAccess(props.module,[ACTION.DELETE])) {
                options = [...options,deleteRow];
            }
            options = [...options, employeeView];
            break;
          case TABLES.CUSTOME_FIELD_LIST:
            if(PermissionUtils.hasAccess(props.module,[ACTION.DELETE])) {
                options = [deleteRow];
            }
            break;
          case TABLES.COMPONENT_GROUP_LIST:
            if(PermissionUtils.hasAccess(props.module,[ACTION.DELETE])) {
                options = [deleteRow];
            }
            break;
          case TABLES.PAYSTUB_LIST:
          case TABLES.PEOPLE_OVERTIME_RATE_CONFIG:
            options = [];
            break;
          case TABLES.PEOPLE_DOCUMENT:
            options = [
              {
                title: "Upload Signed",
                icon: ic_upload,
                className: "",
                onClick: (data) => {
                  if (props.onDocumentDownloadSigned) {
                    props.onDocumentDownloadSigned(data, true);
                  }
                },
              },
              {
                title: "Download Signed",
                icon: DKIcons.ic_download,
                onClick: (data) => {
                  if (props.onDocumentUploadSigned) {
                    props.onDocumentUploadSigned(data, true);
                  }
                },
              },
            ];
            break;
          case TABLES.TEAM_ATTENDANCE:
          case TABLES.PEOPLE_DASHBAORD_TEAM_ATTENDANCE:
            let team_options:any = [];
            if(PermissionUtils.hasAccess( MODULE.TEAM_REPORT,[ACTION.CREATE])) {
                team_options = [...team_options, {
                    title: "Clock In",
                    className: "",
                    onClick: (data) => {
                      if (props.onClockIn && PermissionUtils.hasAccess(MODULE.TEAM_REPORT, [ACTION.CREATE])){
                        props.onClockIn(data);
                      } else {
                        showAlert("Info", "You does not have access to Clock In")
                      }
                    },
                  },
                  {
                    title: "Clock Out",
                    onClick: (data) => {
                      if (props.onClockOut && PermissionUtils.hasAccess(MODULE.TEAM_REPORT, [ACTION.CREATE])){
                        props.onClockOut(data);
                      } else {
                        showAlert("Info", "You does not have access to Clock Out")
                      }
                    },
                  },
                  ]
            }
            if(PermissionUtils.hasAccess(MODULE.TEAM_REPORT,[ACTION.EDIT])) {
                team_options.push({
                    title: "Edit",
                    onClick: (data) => {
                      if (props.onRowEdit && PermissionUtils.hasAccess(MODULE.TEAM_REPORT, [ACTION.EDIT])){
                          props.onRowEdit(data);
                      } else {
                        showAlert("Info", "You does not have access to Edit attendance.")
                      }
                    },
                  })
            }
            if(props.openDetail) {
                team_options = [
                    {
                        title: "View Detail",
                        icon: ic_visibility,
                        onClick: (data) => {
                          if (props.openDetail) {
                              props.openDetail(data);
                          }
                        }
                    }
                ]
            }
            const isAdmin = TenantService.get(TENANT.IS_ADMIN);
            const isManager = TenantService.get(TENANT.IS_MANAGER);
            if (isAdmin || isManager || PermissionUtils.hasAccess(MODULE.TEAM_REPORT,[ACTION.VIEW])) {
              options = team_options;
            }
            break;
            case TABLES.PEOPLE_OVERTIME_LIST:
                let viewSummary = {
                    title: 'View Summary',
                    icon: ic_visibility,
                    className: 'p-0',
                    onClick: (data: any) => {
                        if (props.onView) {
                            props.onView(data);
                        }
                    }
                };
                if(PermissionUtils.hasAccess(props.module,[ACTION.EDIT])) {
                    options = [viewSummary];
                }
                
                break;
            case TABLES.PEOPLE_TIMESHEET_REPORT:
                let approve =  {
                    title: "Approve",
                    icon: ic_check_mark,
                    onClick: (data) => {
                      if (props.onApproveReject) {
                          props.onApproveReject(data,true);
                      }
                    }
                  };
                  let reject =  {
                    title: "Reject",
                    icon: DKIcons.ic_close,
                    onClick: (data) => {
                      if (props.onApproveReject) {
                          props.onApproveReject(data,false);
                      }
                    }
                  };
                options = [approve,reject]
                if(PermissionUtils.hasAccess(props.module,[ACTION.DELETE])) {
                    options = [...options,deleteRow]
                }
                break;
          case TABLES.PEOPLE_MULTIPLE_EXPENSE:
            if(PermissionUtils.hasAccess(props.module,[ACTION.DELETE])) {
                options = [deleteRow]
            }
            break;
          case TABLES.PEOPLE_APPLY_COMP_OFF_REQUEST:
            options = [...options,deleteRow];
            break;
        case TABLES.PAYROLL_PROCESS:
            if(props.module === MODULE.PAYRUN && PermissionUtils.hasAccess(props.module,[ACTION.EDIT])) {
                options = [deleteRow]
            } else if(props.module === MODULE.CONTRACTOR_PAYRUN && PermissionUtils.hasAccess(props.module,[ACTION.DELETE])) {
                options = [deleteRow]
            }
            break;
          default:
            if(PermissionUtils.hasAccess(props.module,[ACTION.DELETE])) {
                options = [deleteRow]
            }
        }
        if(props.displayTableName == 'Timesheet') {
            let submit =  {
                title: "Submit",
                icon: ic_check_mark,
                onClick: (data) => {
                  if (props.onSubmit) {
                      props.onSubmit(data);
                  }
                }
              };
            options = [submit]
            if(PermissionUtils.hasAccess(props.module,[ACTION.DELETE])) {
                options = [...options,deleteRow]
            }
        }

        return options;
    }
    const getRecords = (search = '', payload = state.filter): void => {
        console.log(`${state.tableName}: getRecords called...`);
    };
    const getColumns = () => {
        Table.getTable(TableManger.getTableId(getTableName())).then(
            (data) => {
              TableManger.setTableColumns(data, getTableName());
              updateColumns(true);
            },
            (err) => { }
          );
    };
    
    const updateColumns = (isColumnUpdate=false) => {
        if (props.tableName == TABLES.PEOPLE_MULTIPLE_EXPENSE && !Utility.isEmpty(state.columns)) {
            let gridColumns = isColumnUpdate ? TableManger.getTableVisibleColumns(props.tableName) : props.gridData.columnData// state.columns //For Future reference
            gridColumns = gridColumns.map((col) => {

                switch (col.columnCode) {
                    case COLUMN_CODE.PEOPLE_MULTIPLE_EXPENSE.ATTACHMENTS:

                        col['renderer'] = attachmentRenderer;
                        col['allowFilter'] = false;
                        break;

                    default:
                }

                col['disableWebhook'] = ![
                    INPUT_TYPE.TEXT,
                    INPUT_TYPE.EMAIL,
                    INPUT_TYPE.NUMBER,
                ].includes(col.type);

                return col;
            });
            setState({
                ...state,
                tableName: props.tableName,
                rows: props.gridData.rowData,
                filter: props.filter,
                originalData: props.gridData.originalData || [],
                needNoDataView: props.gridData.rowData.length === 0,
                currentPage: props.currentPage ?? 1,
                totalPageCount: props.totalPageCount ?? 1,
                showContextMenu:false,
                isAllRowSelected:false,
                onRowOpenBtnHidden: ((props.onRowOpenBtnHidden) ? props.onRowOpenBtnHidden: false),
                isShowRevert:  false,
                columns: getUpdatedColumnData(gridColumns)
            });
            
            
        } else if(isColumnUpdate) {
            let gridColumns = TableManger.getTableVisibleColumns(getTableName()) // state.columns //For Future reference
            if (props.onColumnShift) props.onColumnShift(gridColumns);
        }
        
    };
    const attachmentRenderer = ({ value, rowIndex }: any) => {
        let attachment = [],
          jsonData = [];
        if (!Utility.isEmpty(value)) {
          jsonData = Utility.decodeJSON(value);
          jsonData.forEach((data) => {
            attachment.push(
              <DKTooltipWrapper content={renderFile(data)} tooltipClassName="">
                <DKButton
                  icon={Utility.getFileIcon(data.title)}
                  className="p-0"
                  style={{ padding: "0px 2px", opacity: 0.8 }}
                  onClick={() => {
                    window.open(data.path, "_blank");
                  }}
                />
              </DKTooltipWrapper>
            );
          });
        }
        attachment.push(
          <div
            className="parent-height parent-width cursor-hand"
            onClick={() => {
              addAttachment(rowIndex);
            }}
          />
        );
        return (
          <div
            className="row"
            style={{ overflowX: "auto", scrollbarWidth: "thin", height: "inherit" }}
          >
            {attachment}
          </div>
        );
    };
    const getUpdatedColumnData = (columns) => {
        if (!isViewportLarge()) {
          return columns.map((columnData) => ({
            ...columnData,
            width: Math.floor(columnData.width / 1.5),
          }));
        }
    
        return columns;
      };
      const renderFile = (file) => {
        let fileType = file.title?.split(".").pop();
        if (fileType === FILE_TYPE.TXT || fileType === FILE_TYPE.PDF) {
          return `<iframe width="180" src="${file.path}" title="${file.title}"></iframe>`;
        } else if (
          fileType === FILE_TYPE.JPG ||
          fileType === FILE_TYPE.JPEG ||
          fileType === FILE_TYPE.PNG ||
          fileType === FILE_TYPE.SVG
        ) {
          return `<img width="180" src="${file.path}" alt="${file.title}" />`;
        } else {
          return i18next.t('NO_PREVIEW');
        }
      };
      const addAttachment = (index) => {
        let data = {
          rowData: state.rows[index],
          rowIndex: index,
        };
        setState(
            
          {
            ...state,
            attachmentData: data,
          }
        );
        openAttachmentPicker()
      };
      const openAttachmentPicker = () => {
        setAttachmentPickerExists(true)
        if(attachmentOpenFileRef) {
            attachmentOpenFileRef?.current?.click();
        }
      };
    const onRowUpdate = (data: any) => {
        let { rowData, columnKey } = data;
        const sanitizedInput = stringSanitizer(rowData[columnKey]);
        rowData[columnKey] = sanitizedInput;
        if (props.onRowUpdate) props.onRowUpdate(data);  
    };
    const onColumnUpdate = (data: any) => {
        // TODO: persist this in column config DB
        if (props.onColumnUpdate) props.onColumnUpdate(data);
    };
    const onColumnShift = (data: any) => {
        switch(getTableName()) {
            case 'automation':
                return;                
        }
        let { newIndex, oldIndex } = data;
        if(props.tableName === TABLES.PAYROLL_PROCESS) {
            newIndex = newIndex - 1;
            oldIndex = oldIndex - 1;
          }
        if (newIndex < 0) {
          newIndex = oldIndex;
        }
        let newColumnArray = shiftArrayElement(
          [...state.columns],
          oldIndex,
          newIndex
        );
        let tableName = getTableName()
        
        Table.shiftColumn(
          newColumnArray.map((column) => column?.id),
          TableManger.getTableId(tableName)
        ).then((data) => {
          getColumns();
        });
    };
    const getTableName=()=>{
        let tableName = props.tableName
        if(props.formType) {
            switch(props.formType ) {
                case STATUTORY_CONSTANT.EPF.type:
                    tableName = TABLES.PEOPLE_EPF_TAX_REPORT
                    break;
                case STATUTORY_CONSTANT.PT.type:
                    tableName = TABLES.PEOPLE_PROFSESSION_TAX_REPORT
                    break;
                case STATUTORY_CONSTANT.ESI.type:
                    tableName = TABLES.PEOPLE_ESI_TAX_REPORT
                    break;
                default:
                    tableName = props.tableName
            }
        }
        return tableName;
    }
    const updateColumnIndex = (data) => {
        let { newIndex, oldIndex } = data;
        try{
            if(props.isActionEnabled && props.isActionColumnFirst && oldIndex != 0 && newIndex != 0) {
                newIndex = newIndex - 1;
                oldIndex = oldIndex - 1;
            }
        }catch(err) {
            return {newIndex, oldIndex};
        }
        return {newIndex, oldIndex};
    }

    const onRowAdd = (data: any) => {
        const { rowData } = data;
        if (props.onRowAdd) {
            props.onRowAdd(rowData);
        }
    };

    const onColumnAdd = (data: any) => {
        if (props.onColumnAdd) {
            const columnData = data.columnData;
            const newColumn = {
                id: columnData.key,
                key: columnData.key,
                type: columnData.type,
                columnCode: columnData.key,
                editable: true,
                index: state.columns.length + 1,
                name: columnData.name,
                width: columnData.width,
                options: columnData.options,
                hidden: false,
                uiVisible: false
            };
            props.onColumnAdd(newColumn);
        }
    };
    const onColumnDelete = (data: any) => { };

    const onRowClick = (rowIndex: any, rowData: any) => {
        if (props.onRowClick) {
            props.onRowClick(rowIndex, rowData);
        }
    };
    const onPagination = (requestedPageNumber: number) => {
        if (props.onPaginationClick) {
            props.onPaginationClick(requestedPageNumber);
        }
    };

    const onSearch = (searchTerm: string) => {
        if (props.onSearch) {
            props.onSearch(searchTerm);
        }
    };
    const onRowExpand = (value)=>{
        
        setState({
            ...state,
            isRowExpanded:value.rowData.expanded
        })
        if(props.onRowExpand) {
            props.onRowExpand(value)
        }
    }
    const onFilter = (data: any) => {
        if (data && data.query) {
            const queries: any[] = data.query;
            let dataList = [...state.originalData];
            queries.forEach((query) => {
                let filteredDataList: any[] = [];
                const { key, condition, value } = query;
                dataList.forEach((data) => {
                    if (condition === 'eq') {
                        if (data[key] == value) {
                            filteredDataList.push(data);
                        }
                    } else if (condition === 'gt' && typeof data[key] === 'number') {
                        if (data[key] > value) {
                            filteredDataList.push(data);
                        }
                    } else if (condition === 'lt' && typeof data[key] === 'number') {
                        if (data[key] < value) {
                            filteredDataList.push(data);
                        }
                    } else if (condition === 'c' && data[key]) {
                        if(Array.isArray(value)) {
                            if(typeof value[0] === "bigint" && data[key] === value[0]) {
                                filteredDataList.push(data);
                            } else if (typeof value[0] === "string" && data[key].toString().toLowerCase().includes(value[0].toLowerCase())) {
                                filteredDataList.push(data);
                            }
                        } else if (
                            data[key].toString().toLowerCase().includes(value.toLowerCase())
                        ) {
                            filteredDataList.push(data);
                        }
                    } else if (condition === 'sw' && data[key]) {
                        const valueLength: number = data[key].toString().length;
                        const searchKey: string = data[key]
                            .toString()
                            .substring(0, Math.round(valueLength / 2));
                        if (
                            searchKey.toLowerCase().includes(value.toString().toLowerCase())
                        ) {
                            filteredDataList.push(data);
                        }
                    } else if (condition === 'ew' && data[key]) {
                        const valueLength: number = data[key].toString().length;
                        const searchKey: string = data[key]
                            .toString()
                            .substring(Math.round(valueLength / 2), valueLength);
                        if (
                            searchKey.toLowerCase().includes(value.toString().toLowerCase())
                        ) {
                            filteredDataList.push(data);
                        }
                    }
                });
                dataList = [...filteredDataList];
            });
            if (props.onFilter) {
                props.onFilter(dataList, queries);
            }
        }
    };
    const onRowSelect = (data = null) => {
        if (data) {
            if(props.tableName === TABLES.PEOPLE_IRAS_AIS_SUBMISSION) {
                state.rows.forEach((row) => {
                    if(row.selected) {
                        selection.push(row);
                    }
                })
            } else {
                const index = selection.findIndex(
                    (item) =>
                      (data.rowData.id && item.id === data.rowData.id) ||
                      (data.rowData.userId && item.userId === data.rowData.userId) ||
                      (item.data?.employeeId && data.rowData?.data?.employeeId && data.rowData.data.employeeId === item.data.employeeId) ||
                      (data.rowData.data &&
                        data.rowData.data.id &&
                        item.data.id &&
                        item.data.id === data.rowData.data.id &&
                        item?.data?.role?.toLowerCase() === data?.rowData?.data?.role?.toLowerCase())
                  );
                  if (data && data.rowData && data.rowData.selected && index === -1) {
                    selection.push(data.rowData);
                  } else if(data && data.rowData && !data.rowData.selected){
                    selection.splice(index, 1);
                  }
            }
          }
        setState({
            ...state,
            isShowRevert:isRevertPayrunEnabled(),
            showContextMenu: !(selection.length === 0),
        });
        if(props.onSelection) {
            props.onSelection(selection)
        }
        if(props.onRowSelect)
            props.onRowSelect(data)
     };
    const onAllRowSelect = (data: any) => {

        selection.splice(0, state.rows.length)
        if (data) {
            state.rows.forEach(ele => {
                selection.push(ele)
            })
        }
        setState({
            ...state,
            showContextMenu: !(selection.length === 0),
            isAllRowSelected: data
        });
        if(props.onSelection) {
            props.onSelection(selection)
        }
    };
    const onContextMenuOp = (data: any) => { };
    const getDeleteConfirmation = (data: any) => {
        if (props.onRowDelete) {
            props.onRowDelete(data);
            // setState({ ...state, showContextMenu: false, isAllRowSelected: false });
            setSelection([])
        }
    };
    const isEdit = (data: any) => {
        if (props.onRowEdit) {
            props.onRowEdit(data);
        }
    };
    const onContextMenuCancel = () => {
        // selection.splice(0,selection.length)
        // setState({ ...state,showContextMenu: false });
        // getRecords()
        if (props.onCancelContext) {
            setSelection([])
            props.onCancelContext();
        }
     };

     const showEditProp = () =>{
         if (props.tableName == TABLES.PAYROLL_SUMMARY) {
            return false
         } else if (typeof(props.showContextEdit) === "boolean"){
            return props.showContextEdit
         }

         return true
     }
     const isRevertPayrunEnabled=()=> {
        let isEnabled = false;
        if ( selection.length == 1 && selection[0].allowToRevertDelete) {
            isEnabled = true;
        }
        return isEnabled;
    }
    const onSort =(data)=>{
        if(props.onSort) {
            props.onSort(data);
        }
    }
    const initializeImageSelect = () => {
        document.body.onfocus = checkIt;
    };
    const checkIt = () => {
        if (document.querySelector("#dataGridAttachment")) {
          const fileElement = document.querySelector(
            "#dataGridAttachment"
          ) as HTMLInputElement;
          if (fileElement.files && fileElement.files.length === 0) {
            if (props.uploadFile) {
                props.uploadFile(null)
            }
            setAttachmentPickerExists(false)
            return;
          }
        }
    };
    const getAttachmentPicker = () => {
        return (
            <input
                id="dataGridAttachment"
                type="file"
                accept={CANDIDATE_ACCEPT_FILE_TYPE.join()}
                ref={attachmentOpenFileRef}
                style={{ display: "none" }}
                onClick={(e) => {
                    initializeImageSelect();
                    e.stopPropagation();
                }}
                
                onChange={(e) => {
                    if (e.target.files.length > 0) {
                        const fileSize = e.target.files[0].size / 1024 / 1024;
                        if (fileSize > 10) {
                            showAlert(
                                i18next.t('FILE_SIZE_HEADER'),
                                i18next.t('FILE_SIZE_ERROR')
                            );
                            return;
                        }
                        uploadImageToAWS(e.target.files[0]);
                    }
                }}
            />
        );
    };
    const uploadImageToAWS = (imageData) => {
        let rowData = { ...state.attachmentData.rowData };
        triggerAttachmentUpload(imageData, state.attachmentData.rowIndex, rowData)
        setAttachmentPickerExists(false)
    }
    const triggerAttachmentUpload = (file, rowIndex, rowData) => {
        let obj = {
            entityName: ENTITY.EXPENSE
        }
        ExpenseService.uploadAttachment(file, obj).then((res: any) => {
            if (res && res.attachmentId) {
                let newAttachment = {
                    title: file.name,
                    type: file.type,
                    path: URL.createObjectURL(file),
                    attachmentId: res.attachmentId
                };
                if (props.uploadFile) {
                    props.uploadFile({ ...res, file: newAttachment, rowIndex: rowIndex, rowData: rowData })
                }
            }
        },
            error => {
                if (error?.status === 500 && error?.message?.includes("CONTENT_TYPE_NOT_ALLOWED")) {
                    showAlert(i18next.t('FAIL_TO_UPLOAD'), i18next.t('FILE_FORMAT_TYPE_ERROR_MSG'));
                } else {
                    showToast(i18next.t("ERROR_UPLOAD"), TOAST_TYPE.FAILURE);
                }
            })
    };
    const isHasAddButtonConfigVisible = () => {
        const hasAccessToAddButton = (
            PermissionUtils.hasAccess(props.module,[ACTION.CREATE]) && //only CREATE / add row
            props.addButtonConfig
        ) ? props.addButtonConfig : undefined
        if(props.module) {
            switch(props.module) {
                case MODULE.GIRO:
                    return props.addButtonConfig ? props.addButtonConfig : undefined;
                case MODULE.COMPANY_SETTINGS:
                    if(props.tableName === TABLES.CUSTOME_FIELD_LIST) {
                        return (
                            PermissionUtils.hasAccess(props.module,[ACTION.EDIT]) && //only CREATE / add row
                            props.addButtonConfig
                        ) ? props.addButtonConfig : undefined
                    } else {
                        return hasAccessToAddButton
                    }
                case MODULE.EXPENSE_CLAIM:
                    if(props.tableName === TABLES.PEOPLE_EXPENSE_CLAIMS) {
                        return  props.addButtonConfig || undefined
                    } else {
                        return hasAccessToAddButton
                    }
                case MODULE.EMPLOYEE:
                    if (props.tableName === TABLES.PEOPLE_DOCUMENT) {
                        return  props.addButtonConfig || undefined
                    } else {
                        return hasAccessToAddButton
                    }
                default:
                    return hasAccessToAddButton
            }
        } else {
            return props.addButtonConfig ? props.addButtonConfig : undefined
        }
        
    }
    const getDataGrid = () => (
        <>

                {(state.showContextMenu && props.isMenuVisible) && (
                    <ContextMenu
                        tableName={state.tableName||props.tableName}
                        isShowEdit={selection.length === 1 && showEditProp() ? true:false}
                        displayTableName={props.displayTableName ? props.displayTableName: state.tableName}
                        onDelete={() => getDeleteConfirmation(selection)}
                        onApply={(data) => onContextMenuOp(data)}

                        isCheckPrint={props.isCheckPrint}

                        onCheckPrint={()=>(props.onCheckPrint ? props.onCheckPrint() : false)}
                        onCancel={() => onContextMenuCancel()
                        }
                        onEdit={()=>isEdit(selection)}
                        selection={selection}
                        isShowRevert={(selection.length === 1 && state.isShowRevert) || false}
                        onRevertClick={(data)=>{props.onRevertClick(data)}}
                        hideTableName={props.hideTableName}
                        addMenuButton = {props.addMenuButton ? props.addMenuButton : undefined}
                        module={props.module}
                    />
                )}
                {!props.isHideTooltip && <ReactTooltip 
                    className="warning-tooltip-react" 
                    backgroundColor={REACT_TOOLTIP_CONST.backgroundColor} 
                    borderColor={REACT_TOOLTIP_CONST.borderColor} 
                    border={REACT_TOOLTIP_CONST.border} 
                    textColor={REACT_TOOLTIP_CONST.textColor} 
                    place="right" html={true} effect='solid' 
                />}
                <DKDataGrid
                    title={props.displayTableName}
                    width={props.gridWidth ? props.gridWidth : width}
                    columns={
                        (props.isActionEnabled ? (props.isActionColumnFirst ? [getActionButtonsColumn(),...state.columns] : [...state.columns, getActionButtonsColumn()]):[...state.columns])
                    }
                    rows={[...state.rows]}
                    currentPage={state.currentPage}
                    totalPageCount={state.totalPageCount}
                    onRowUpdate={onRowUpdate}
                    onColumnUpdate={onColumnUpdate}
                    onColumnShift={onColumnShift}
                    onRowAdd={onRowAdd}
                    onRowClick={onRowClick}
                    onColumnAdd={onColumnAdd}
                    onColumnDelete={onColumnDelete}
                    onSearch={(data: any) => onSearch(data)}
                    onFilter={(data: any) => onFilter(data)}
                    allowExpand={props.allowExpand}
                    onRowExpand={onRowExpand}
                    allowRowAdd={props.allowRowAdd}
                    allowRowEdit={props.allowRowEdit}
                    allowColumnAdd={false}
                    allowColumnEdit={props.allowColumnEdit}
                    allowColumnDelete={props.allowColumnDelete}
                    allowColumnShift={props.allowColumnShift}
                    allowSearch={props.allowSearch}
                    allowFilter={props.allowFilter}
                    allowColumnSort={props.allowColumnSort}
                    allowBulkOperation={props.allowBulkOperation}
                    onPrevPageTapped={() => onPagination(state.currentPage - 1)}
                    onNextPageTapped={() => onPagination(state.currentPage + 1)}
                    onPageChange={(page) => onPagination(page)}
                    filterData={state.filter}
                    onRowSelect={(data: any) => onRowSelect(data)}
                    onAllRowSelect={(data: any) => onAllRowSelect(data.selected)}
                    showHeader={!((state.showContextMenu&& props.isMenuVisible)||props.isHeaderHidden)}
                    addButton={isHasAddButtonConfigVisible} 
                    contextMenu={(props.contextMenu && !state.isRowExpanded) ? getGridContextMenu() : ''}
                    isAllRowSelected={state.isAllRowSelected}
                    onRowOpenClick={state.onRowOpenBtnHidden ? false : ( (rowData,rowIndex)=> props.onRowEdit(rowData, true))}
                    buttons = {isHasAddButtonConfigVisible()}
                    onSort={props.onSort ? ( (data) =>onSort(data)):null }
                    dateFormat={props.dateFormat}
                    needTrailingColumn={props.needTrailingColumn}
                    updating={props.updating ? props.updating: false}
                />
                {getAttachmentPicker()}

        </>
    );

    return (
        <div className={`${props.gridWidth ? "":" parent-height " } column `}>
            {getDataGrid()}
            {state.needNoDataView && getNoDataView()}
        </div>
    );

};
export default DataGridHolderPayroll;
function isActionColumn(tableName){
        var tablesNotAction = [TABLES.ATTENDANCE,TABLES.TEAM_ATTENDANCE];
        var index = tablesNotAction.indexOf(tableName);
        return (index == -1) ? true:false
}
